import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableLoggedOutDraftApproval = Loadable({
  loader: function loader() {
    return import('../LoggedOutDraftApproval.jsx');
  },
  loading: ComponentLoading
});
export default LoadableLoggedOutDraftApproval;